import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { catchError, debounceTime, firstValueFrom, map, merge, mergeMap, of, repeat, switchMap } from 'rxjs';
import { LoginSettingsApiService } from '../../services';
import { LoginSettingsActions } from '../actions';
import { LoginSettingsSelectors } from '../selectors';

@Injectable()
export class LoginSettingsEffects {
  private readonly actions$ = inject(Actions);
  private readonly loginSettingsApiService = inject(LoginSettingsApiService);
  private readonly store = inject(Store);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoginSettingsActions.Load),
      mergeMap(() => this.loginSettingsApiService.getLoginSettings()),
      map((loginSettings) => LoginSettingsActions.Loaded({ loginSettings })),
    ),
  );

  saveChanges$ = createEffect(() =>
    merge(
      ...[
        LoginSettingsActions.ToggleEmailLogin,
        LoginSettingsActions.ToggleIdp,
        LoginSettingsActions.ToggleSupportTeamLogin,
      ].map((action) => this.actions$.pipe(ofType(action))),
    ).pipe(
      debounceTime(1000),
      switchMap(() => firstValueFrom(this.store.pipe(select(LoginSettingsSelectors.selectLoginSettings)))),
      switchMap((lastSettings) => this.loginSettingsApiService.updateLoginSettings(lastSettings)),
      map(() => LoginSettingsActions.ChangesSaved()),
      catchError(() => of(LoginSettingsActions.SaveChangesFailed())),
      repeat()
    ),
  );
}
